import { FC, useState } from "react";
import { cloneDeep } from "lodash";
import { Radio, Button, Spin } from "antd";
import * as XLSX from "xlsx";
import { find } from "lodash";

import { formatDownloadFileNameDate, formatDownloadDate, formatNumber } from "@utils/helpers";
import "./downloadSection.scss";
import membersService from "@services/members.service";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useMemberListStore } from "@stores/useMemberListStore";

type TDownloadProps = {
  columns: any;
  downloadType: any;
  sortData:any;
  reminderStartFilter: any;
  reminderEndFilter: any;
  totalUser: any;
  onClose: any;
  totalUserCount: any;
  adtState: string;
  searchOn?: any;
  patientListForFilter: any[];
  filters: any;
  //@Author : kishore
  //@description : downloadColData is so that when download detail is done the dropdown value columns will also be added
  downloadColData?: any;
};

// Secure API File Download Helper
export const downloadFileViaAPI = async (blobUrl: string, fileName: string) => {
  let objectUrl: string | null = null;
  let link: HTMLAnchorElement | null = null;

  
  membersService.downloadBlobFile(blobUrl).subscribe({
    next: async (v: any) => {
    // 6. Convert response to Blob
    const blob = v.data
    objectUrl = window.URL.createObjectURL(blob);

    // 7. Trigger the browser's native file download
    link = document.createElement("a");
    link.href = objectUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  },
  });
};

const DownloadSection: FC<TDownloadProps> = ({
  totalUser,
  totalUserCount,
  downloadColData,
  onClose,
  columns,
  downloadType,
  sortData = {},
  reminderStartFilter,
  reminderEndFilter,
  adtState,
  filters,
  searchOn,
  patientListForFilter,
}: TDownloadProps) => {
  // const [checkAllUser, setCheckAllUser] = useState(true);
  const [columnsType, setColumnsType] = useState("detail");

  // const [rangeFrom, setRangeFrom] = useState('1');
  // const [rangeTo, setRangeTo] = useState(formatNumber(totalUser.length));
  const [showLoader, setShowLoader] = useState(false);

  const memberListRegistryDropDown = useMemberListStore((state) => state.memberListRegistryDropDown);

  // const toggleCheckAll = () => {
  //     // setCheckAllUser(prevState => !prevState);
  // }
  const setColumnsTypeRadio = (event: any) => {
    setColumnsType(event.target.value);
  };

  // const updateFrom = (event:any) => {
  //     let val = event.target.value.replaceAll(',','');
  //     if(isValidNumber(val) || val === '') {
  //         setRangeFrom(formatNumber(val));
  //         // setCheckAllUser(false);
  //     }
  // }
  // const updateTo = (event:any) => {
  //     let val = event.target.value.replaceAll(',','');
  //     if(isValidNumber(val) || val === '') {
  //         setRangeTo(formatNumber(val));
  //         // setCheckAllUser(false);
  //     }
  // }

  // Secure API File Download Helper


  const downloadLite = () => {
    let ccData = [...totalUser];
    let data: any[] = [];
    if (columnsType === "lite") {
      data = ccData.map((row: any) => {
        const obj: any = {};
        downloadColData
          .filter((col: any) => col.isSelected && col.dataIndex !== "action" && !["Utilization_Measures_curr_period", "Utilization_Measures_curr_year"].includes(col.dataIndex))
          .forEach((col: any) => (obj[col.dataIndex] = row[col.dataIndex]));
        downloadColData.forEach((col: any) => {
          if (col.subColumns.length > 0 && col.isSelected) {
            col.subColumns.forEach((subCol: any) => {
              if (subCol.dataIndex === "case_last_action_date") {
                obj[subCol.dataIndex] = row[subCol.dataIndex] ? formatDownloadDate(new Date(row[subCol.dataIndex])) : row[subCol.dataIndex];
              } else {
                obj[subCol.dataIndex] = row[subCol.dataIndex];
              }
            });
          }
          if (col.isSelected) {
            if (col.dataIndex === "member_caseload_status") {
              obj[col.dataIndex] = "SYSTEM" === row[col.dataIndex] ? "Y-Auto" : "USER" === row[col.dataIndex] ? "Y-Manual" : "N";
            } else if (
              col.dataIndex === "case_last_action_date" ||
              col.dataIndex === "admission_date" ||
              col.dataIndex === "discharge_date" ||
              col.dataIndex === "er_visit_start_date" ||
              col.dataIndex === "er_visit_end_date"
            ) {
              obj[col.dataIndex] = row[col.dataIndex] ? formatDownloadDate(new Date(row[col.dataIndex])) : row[col.dataIndex];
            } else if (
              col.dataIndex === "patient_eol_status" ||
              col.dataIndex === "patient_frequent_flyer_status" ||
              col.dataIndex === "patient_hrp_status" ||
              col.dataIndex === "patient_hip_status" ||
              col.dataIndex === "patient_ccp_status" ||
              col.dataIndex === "patient_dylpat_status" ||
              col.dataIndex === "patient_canpat_status" ||
              col.dataIndex === "patient_hivpat_status"
            ) {
              obj[col.dataIndex] = row[col.dataIndex] ? row[col.dataIndex] : "N";
            } else if (col.dataIndex === "client_id") {
              obj[col.dataIndex] = row[col.dataIndex] !== null ? (isNaN(Number(row[col.dataIndex])) ? row[col.dataIndex] : "'" + row[col.dataIndex]) : row[col.dataIndex];
            }
          }
        });
        return obj;
      });
    } else {
      data = ccData.map((item: any) => {
        let obj = { ...item };
        obj["member_caseload_status"] = "SYSTEM" === obj["member_caseload_status"] ? "Y-Auto" : "USER" === obj["member_caseload_status"] ? "Y-Manual" : "N";
        obj["case_last_action_date"] = obj["case_last_action_date"] ? formatDownloadDate(new Date(obj["case_last_action_date"])) : obj["case_last_action_date"];
        obj["admission_date"] = obj["admission_date"] ? formatDownloadDate(new Date(obj["admission_date"])) : obj["admission_date"];
        obj["discharge_date"] = obj["discharge_date"] ? formatDownloadDate(new Date(obj["discharge_date"])) : obj["discharge_date"];
        obj["er_visit_start_date"] = obj["er_visit_start_date"] ? formatDownloadDate(new Date(obj["er_visit_start_date"])) : obj["er_visit_start_date"];
        obj["er_visit_end_date"] = obj["er_visit_end_date"] ? formatDownloadDate(new Date(obj["er_visit_end_date"])) : obj["er_visit_end_date"];
        obj["patient_eol_status"] = obj["patient_eol_status"] ? obj["patient_eol_status"] : "N";
        obj["patient_frequent_flyer_status"] = obj["patient_frequent_flyer_status"] ? obj["patient_frequent_flyer_status"] : "N";
        obj["patient_hrp_status"] = obj["patient_hrp_status"] ? obj["patient_hrp_status"] : "N";
        obj["patient_hip_status"] = obj["patient_hip_status"] ? obj["patient_hip_status"] : "N";
        obj["patient_ccp_status"] = obj["patient_ccp_status"] ? obj["patient_ccp_status"] : "N";
        obj["patient_dylpat_status"] = obj["patient_dylpat_status"] ? obj["patient_dylpat_status"] : "N";
        obj["patient_canpat_status"] = obj["patient_canpat_status"] ? obj["patient_canpat_status"] : "N";
        obj["patient_hivpat_status"] = obj["patient_hivpat_status"] ? obj["patient_hivpat_status"] : "N";
        obj["client_id"] = obj["client_id"] !== null ? (isNaN(Number(obj["client_id"])) ? obj["client_id"] : "'" + obj["client_id"]) : obj["client_id"];
        delete obj.notes;
        delete obj.reminders;
        delete obj.alerts;
        delete obj.caremgr_profile;
        delete obj.key;
        // delete obj.patient_id;
        delete obj.risk_category_flag;
        delete obj.hcc_risk_flag;
        delete obj.admissions_risk_flag;
        return obj;
      });
    }

    const dataHeaderSelected = Object.keys(data[0]);
    let customizedData: any[] = [];
    let headersCreatedForFileDownload: any = {};
    let copyColumns = cloneDeep(downloadColData);
    let colOrderMap: Map<any, any> = new Map();

    copyColumns.forEach((element: any) => {
      if ((element?.subColumns?.length > 0 || element?.children?.length > 0) && element.tableHeaderName) {
        element.subColumns
          ? element?.subColumns.forEach((el: any) => colOrderMap.set(el.dataIndex, element.order))
          : element?.children.forEach((el: any) => colOrderMap.set(el.dataIndex, element.order));
      } else if (element.tableHeaderName) {
        colOrderMap.set(element.dataIndex, element.order);
      }
    });
    let sorteddataHeaderSelected = dataHeaderSelected.sort((a: any, b: any) => ((colOrderMap.get(a) || 9999) < (colOrderMap.get(b) || 9999) ? -1 : 1));
    copyColumns.forEach((element: any) => {
      if ((element?.subColumns?.length > 0 || element?.children?.length > 0) && element.tableHeaderName) {
        element.subColumns
          ? element?.subColumns.forEach((el: any) => {
              if (["Utilization_Measures_curr_period", "Utilization_Measures_curr_year"].includes(element.dataIndex)) {
                headersCreatedForFileDownload[el.dataIndex] = `${el.tableHeaderName} [${element.tableHeaderName.split("[")[1]}`;
              } else {
                headersCreatedForFileDownload[el.dataIndex] = el.tableHeaderName;
              }
            })
          : element?.children.forEach((el: any) => {
              if (["Utilization_Measures_curr_period", "Utilization_Measures_curr_year"].includes(element.dataIndex)) {
                headersCreatedForFileDownload[el.dataIndex] = `${el.tableHeaderName} [${element.tableHeaderName.split("[")[1]}`;
              } else {
                headersCreatedForFileDownload[el.dataIndex] = el.tableHeaderName;
              }
              headersCreatedForFileDownload[el.dataIndex] = el.tableHeaderName;
            });
      } else if (element.tableHeaderName) {
        headersCreatedForFileDownload[element.dataIndex] = element.tableHeaderName;
      }
    });

    customizedData = data.map((entries) => {
      let customizedEntries: any = {};
      for (let i = 0; i < sorteddataHeaderSelected.length; i++) {
        if (headersCreatedForFileDownload[sorteddataHeaderSelected[i]]) customizedEntries[headersCreatedForFileDownload[sorteddataHeaderSelected[i]]] = entries[sorteddataHeaderSelected[i]];
        // if (sorteddataHeaderSelected[i]==="prev_case_status")  customizedEntries["Previous Case Status"] = entries[sorteddataHeaderSelected[i]];
        // if (sorteddataHeaderSelected[i]==="patient_hopital_admission_flag")  customizedEntries["Hospital Admission"] = entries[sorteddataHeaderSelected[i]];
        // if (sorteddataHeaderSelected[i]==="patient_hopital_discharge_flag") customizedEntries["Discharged"] = entries[sorteddataHeaderSelected[i]];
        // if (sorteddataHeaderSelected[i]==="patient_hopital_event_datetime") customizedEntries["Hospital Event Date"] = entries[sorteddataHeaderSelected[i]];
      }
      delete customizedEntries.year_month;
      delete customizedEntries.prev_case_status;
      delete customizedEntries.patient_hopital_admission_flag;
      delete customizedEntries.patient_hopital_discharge_flag;
      delete customizedEntries.patient_hopital_event_datetime;

      return customizedEntries;
    });

    const fileName = `Members_List_${columnsType === "lite" ? "Lite" : "Detail"}_${formatDownloadFileNameDate(new Date())}.csv`;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customizedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Selected Members");
    XLSX.writeFile(wb, fileName);
  };

  const downloadAllMembers = () => {
    setShowLoader(true);
    let colList: any[] = [];
    cloneDeep(downloadColData).forEach((col: any) => {
      if (col.subColumns.length > 0) {
        col.subColumns.forEach((subcol: any) => {
          if (col.tableHeaderName) {
            if (["Utilization_Measures_curr_period", "Utilization_Measures_curr_year"].includes(col.dataIndex)) {
              subcol.tableHeaderName = `${subcol.tableHeaderName} [${col.tableHeaderName.split("[")[1]}`;
            }
            colList.push({ key: subcol.key, tableHeaderName: subcol.tableHeaderName });
          }
        });
      }
      if (col.tableHeaderName && col.dataIndex !== "action" && !(col.subColumns.length > 0)) {
        colList.push({ key: col.key, tableHeaderName: col.tableHeaderName });
      }
    });
    if (columnsType === "lite") {
      colList = [];
      cloneDeep(downloadColData)
        .sort((a: any, b: any) => (a.order < b.order ? -1 : 1))
        .forEach((col: any) => {
          if (col.subColumns.length > 0) {
            col.subColumns
              .sort((a: any, b: any) => (a.order < b.order ? -1 : 1))
              .forEach((subcol: any) => {
                if (col.isSelected && col.tableHeaderName) {
                  if (["Utilization_Measures_curr_period", "Utilization_Measures_curr_year"].includes(col.dataIndex)) {
                    subcol.tableHeaderName = `${subcol.tableHeaderName} [${col.tableHeaderName.split("[")[1]}`;
                  }
                  colList.push({ key: subcol.key, tableHeaderName: subcol.tableHeaderName });
                }
              });
          }
          if (col.isSelected && col.tableHeaderName && col.dataIndex !== "action" && !(col.subColumns.length > 0)) {
            colList.push({ key: col.key, tableHeaderName: col.tableHeaderName });
          }
        });
    }

    membersService.downloadAllMembers(colList, reminderStartFilter, reminderEndFilter, sortData , searchOn, filters, adtState, patientListForFilter, columnsType).subscribe({
      next: async (v: any) => { // Make this async
        if (v.data.status === "OK") {
          // OLD CODE: window.open(v.data.data.fileURL, "_blank");
          
          // NEW CODE:
          const fileName = `Members_List_${columnsType === "lite" ? "Lite" : "Detail"}_${formatDownloadFileNameDate(new Date())}.csv`;
          await downloadFileViaAPI(v.data.data.fileURL, fileName);
        }
        setShowLoader(false);
      },
    });
  };

  // function downloadURI(uri: any) {
  //         const link = document.createElement('a');
  //         const fileName = 'AllMembers.csv';
  //         link.setAttribute('download', fileName);
  //         link.href = URL.createObjectURL(new Blob([uri]));
  //         document.body.appendChild(link);
  //         link.click();
  //         link.remove();

  // }
  return (
    <div className="dwonloadSectionWrap">
      <div className="inputSection">
        <div className="checkboxSection">
          {/* <Checkbox indeterminate={false} onChange={toggleCheckAll} checked={checkAllUser}> */}
          <p className="checkAllSection">
            <span className="f16 w500 number">{downloadType === "all" ? totalUserCount : totalUser.length > 0 ? formatNumber(totalUser.length) : 0}</span>
            <span className="f16 w500 details">Members selected</span>
            <br />
            {totalUser.length > 0 ? (
              <span className="f12 subDetail">(Can select upto 70K members only)</span>
            ) : (
              <span className="f12 subDetail" style={{ color: "#e75547" }}>
                (Can select upto 70K members only)
              </span>
            )}
          </p>
          {/* </Checkbox> */}
        </div>
        {/* <div className="inputWrap">
                    <p className="inputHeading">Select Serial no. :</p>
                    <div className="inlineInput">
                        <p className="inputType">From</p>
                        <Input onChange={updateFrom} value={rangeFrom} className="downloadInput" />
                    </div>
                    <div className="inlineInput">
                        <p className="inputType">to</p>
                        <Input onChange={updateTo} value={rangeTo} className="downloadInput" />
                    </div>
                </div> */}
      </div>
      <div className="downloadTypeSection">
        <Radio.Group onChange={setColumnsTypeRadio} value={columnsType}>
          <Radio disabled={totalUser.length === 0} value={"detail"}>
            <div className="detailWrap">
              <p className="detailHead">Download Detail</p>
              <p className="f12 detailSubHead">This version will download all columns</p>
            </div>
          </Radio>
          <Radio disabled={totalUser.length === 0} value={"lite"}>
            <div className="detailWrap">
              <p className="detailHead">Download Lite</p>
              <p className="f12 detailSubHead">This version will download only columns that are visible on screen</p>
            </div>
          </Radio>
        </Radio.Group>
      </div>
      <div className="downloadActionSection cancel-button">
        <Button type="text" size={"large"} onClick={onClose}>
          Cancel
        </Button>
        <Spin spinning={showLoader} indicator={<HealthemSpinner />}>
          <Button
            key={downloadType === "all" ? totalUserCount : totalUser.length > 0 ? formatNumber(totalUser.length) : 0}
            disabled={process.env.REACT_APP_RESTRICTED_DOWNLOAD === 'true' ? (totalUser.length === 0 || (downloadType === "all" ? totalUserCount : totalUser.length > 0 ? formatNumber(totalUser.length) : 0) > 70000 ) : false}
            type="primary"
            size={"large"}
            className="f16 w500 downloadButton"
            onClick={downloadType === "all" ? downloadAllMembers : downloadLite}
          >
            <i className="icon-download" /> Download XLS
          </Button>
        </Spin>
      </div>
    </div>
  );
};

export default DownloadSection;
